/**
 * UI store for transient state (NOT persisted)
 */

import { create } from 'zustand';

interface UIState {
  sidebarOpen: boolean;
  activeModal: string | null;
  globalLoading: boolean;
  toast: {
    message: string;
    type: 'success' | 'error' | 'info' | 'warning';
    visible: boolean;
  } | null;
}

interface UIActions {
  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;
  openModal: (modalId: string) => void;
  closeModal: () => void;
  setGlobalLoading: (loading: boolean) => void;
  showToast: (message: string, type: 'success' | 'error' | 'info' | 'warning') => void;
  hideToast: () => void;
}

export type UIStore = UIState & UIActions;

export const useUIStore = create<UIStore>((set) => ({
  // State
  sidebarOpen: true,
  activeModal: null,
  globalLoading: false,
  toast: null,

  // Actions
  setSidebarOpen: (open) => set({ sidebarOpen: open }),

  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),

  openModal: (modalId) => set({ activeModal: modalId }),

  closeModal: () => set({ activeModal: null }),

  setGlobalLoading: (loading) => set({ globalLoading: loading }),

  showToast: (message: string, type: 'success' | 'error' | 'info' | 'warning') =>
    set({
      toast: {
        message,
        type,
        visible: true,
      },
    }),

  hideToast: () =>
    set({
      toast: null,
    }),
}));
